<div class="container">
    <div *ngIf="currentLocation?.RoleId != 2" class="section-btn search" (click)="search()">
        <p class="title">{{'home.search' | translate}}</p>
        <span class="material-icons">search</span>
    </div>
    <div class="section-btn sign" (click)="goTo('/search')">
        <p class="title">{{'home.sign_and_print' | translate}}</p>
        <span class="material-icons">event_note</span>
    </div>
</div>